"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScreenCapturePlugin = void 0;
var _elementSelectors = require("../constants/elementSelectors");
var _sentPostMessageTypes = require("../iframe-communication/constants/sentPostMessageTypes");
var _WidgetColors = require("visitor-ui-component-library/constants/WidgetColors");
class ScreenCapturePlugin {
  constructor(widgetShell) {
    this.setWidgetVisibility = visible => {
      const parent = document.getElementById(_elementSelectors.PARENT_ID);
      if (parent) {
        parent.style.setProperty('opacity', visible ? '1' : '0');
      }
    };
    this.wrapText = (ctx, text, maxWidth) => {
      const lines = [];
      let line = '';
      for (const char of text) {
        const next = line + char;
        if (ctx.measureText(next).width > maxWidth && line.length > 0) {
          lines.push(line);
          line = char;
        } else {
          line = next;
        }
      }
      if (line) lines.push(line);
      return lines;
    };
    this.addUrlToImage = (canvas, url) => {
      const ctx = canvas.getContext('2d');
      const fontSize = Math.max(12, canvas.height * 0.018);
      const font = `500 ${fontSize}px ui-monospace, SFMono-Regular, Menlo, Consolas, Liberation Mono, monospace`;
      ctx.font = font;
      const padding = 16;
      const lines = this.wrapText(ctx, url, canvas.width - padding * 2);
      const lineHeight = fontSize + 6;
      const urlContentHeight = lines.length * lineHeight + padding;
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const imageHeight = canvas.height;
      canvas.height = imageHeight + urlContentHeight;
      ctx.putImageData(imageData, 0, 0);
      ctx.font = font;
      ctx.fillStyle = _WidgetColors.NEUTRAL_1600;
      ctx.fillRect(0, imageHeight, canvas.width, urlContentHeight);
      ctx.fillStyle = _WidgetColors.WHITE;
      ctx.textBaseline = 'top';
      const textY = imageHeight + (urlContentHeight - lines.length * lineHeight) / 2;
      lines.forEach((line, i) => {
        ctx.fillText(line, padding, textY + i * lineHeight);
      });
    };
    this.captureScreenshot = async () => {
      try {
        const stream = await navigator.mediaDevices.getDisplayMedia({
          // @ts-expect-error This is a non-spec property that forces the browser to capture the current tab
          // but it's only supported in Chrome for now so it's not typed.
          preferCurrentTab: true,
          video: {
            displaySurface: 'browser'
          }
        });
        const video = document.createElement('video');
        video.srcObject = stream;
        await video.play();
        const MAX_PIXELS = 2880 * 1800;
        const capturedPixels = video.videoWidth * video.videoHeight;
        const canvas = document.createElement('canvas');
        if (capturedPixels > MAX_PIXELS) {
          const scale = Math.sqrt(MAX_PIXELS / capturedPixels);
          canvas.width = Math.round(video.videoWidth * scale);
          canvas.height = Math.round(video.videoHeight * scale);
        } else {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
        }
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          this.addUrlToImage(canvas, window.location.href);
        }
        stream.getTracks().forEach(track => track.stop());
        return canvas.toDataURL('image/png');
      } catch (e) {
        this.widgetShell.devLogger.error(e instanceof Error ? e.message : 'Unknown error');
      }
    };
    this.handleScreenCaptureRequest = async () => {
      this.setWidgetVisibility(false);
      const dataUrl = await this.captureScreenshot();
      if (dataUrl) {
        const fileName = `${document.title}-${Date.now()}.png`;
        this.widgetShell.iframeMessage.post(_sentPostMessageTypes.SCREEN_CAPTURE_BLOB, {
          dataUrl,
          fileName
        });
      }
      this.setWidgetVisibility(true);
    };
    this.widgetShell = widgetShell;
  }

  /**
   * Captures a screenshot of the current tab using the browser's mediaDevices API
   * @returns {Promise<string>} A promise that resolves to the dataUrl of the screenshot
   */
}
exports.ScreenCapturePlugin = ScreenCapturePlugin;